import request from '@/utils/request'
import store from '@/store'
export default {
  // 2026-07-30：统一读取后端可配置的产品版本信息。
  getReleaseInfo:()=> {
    return request({
      url: 'land/releaseInfo',
      method: 'GET'
    })
  },
  // 2026-09-03：平台与分店 C 端固定读取平台机构的全局维护状态。
  getPublicPlatformInfo:()=> {
    return request({
      // 2026-09-03：维护状态查询增加时间戳，避免客户端缓存旧状态而延迟锁定或恢复。
      url: `land/orgidid?orgId=1000&_maintenanceTs=${Date.now()}`,
      method: 'GET'
    })
  },
  login: (data: any) => {    
    data.orgId=store.getters.orgId
    return request({
      url: 'auth/frontlogin',
      method: 'POST',
      data
    })
  },
  getUserInfo: () => {
    return request({
      url: 'sys/profile',
      method: 'GET',
    })
  },
  getCourses:()=> {
    const orgId=store.getters.orgId
    return request({
      url: `land/courses?orgId=${orgId}`,
      method: 'GET'
      
    }) 
  },
  getCourse:(id)=> {
    return request({
      // 2026-10-02：声明支持有序图文目录，后端对旧客户端继续返回可读文字。
      url: `land/course?id=${id}&catalogFormat=blocks-v1`,
      method: 'GET'
      
    }) 
  },
  //添加系统信息
  insertSysMessages: (data) => {
    return request({
      url: 'land/insertSysMessages',
      method: 'POST',
      data,
    })
  },
  //查询所有系统信息
  getSysMessages: () => {
    return request({
      url: 'system/sysMessages',
      method: 'GET',
    })
  },
  reserveAudit: (id) => {
    return request({
      url: `fsystem/reserve?orgId=${id}`,
      method: 'GET',
    })
  },
  getOrgByOrgName: (name) => {
    return request({
      url: `fsystem/orgByOrgName?name=${name}`,
      method: 'GET',
    })
  },
  insertSysOperator: (data) => {
    return request({
      url: 'system/addOperator',
      method: 'POST',
      data
    })
  },
  editOperator: (data) => {
    return request({
      url: 'system/editOperator',
      method: 'POST',
      data
    })
  },  
  sysOperatorBySearch: (data) => {
    return request({
      url: 'system/operators',
      method: 'POST',
      data
    })
  },
  
  getRoles: (orgId) => {
    return request({
      url: 'system/roles/'+orgId,
      method: 'GET',
    })
  },
  addOrg:(data) => {
    return request({
      url: 'fsystem/addOrg',
      method: 'POST',
      data
    })
  },
  editOrg:(data) =>{
    return request({
      url: 'fsystem/editOrg',
      method: 'POST',
      data
    })
  },
  addRole:(role)=>{
    return request({
      url: 'system/addRole',
      method: 'POST',
      data:role
    }) 
  },
  setMainOrg:(role)=>{
    return request({
      url: 'system/setMainOrg',
      method: 'POST',
      data:role
    }) 
  },  
  editOrgOther:(data)=>{
    return request({
      url: 'fsystem/addEditOrgOther',
      method: 'POST',
      data:data
    }) 
  },
  getOrgOther:(id)=>{
    return request({
      url: 'land/orgOther/'+id,
      method: 'GET'
    }) 
  },
  deleteRole:(role)=>{
    return request({
      url: 'system/deleteRole',
      method: 'DELETE',
      data:role
    }) 
  },
  deleteRoleFunction:(id)=>{
    return request({
      url: 'system/deleteRoleFunction/'+id,
      method: 'DELETE'
    }) 
  },
  deleteBrand:(id)=>{
    return request({
      url: 'system/deleteBrand/'+id,
      method: 'DELETE'
    }) 
  },
  addBrand:(data) => {
    return request({
      url: 'system/addBrand',
      method: 'POST',
      data
    }) 
  },
  updateSysOperatorDisable: (data) => {
    return request({
      url: 'system/updateSysOperatorDisable',
      method: 'POST',
      data
    })
  },
  getMyOrgs:(id)=>{
    return request({
      url: `fsystem/myOrgs?customerId=${id}`,
      method: 'GET',
    })
  },
  getDepositeSettings:()=>{
    const orgId=store.getters.orgId
    return request({
      url: `fsystem/depositeSettings?orgid=${orgId}`,
      method: 'GET',
    })
  },
  getOrgId:(hostname)=>{
    return request({
      url: `land/orgid?hostname=${hostname}`,
      method: 'GET',
    })
  },
  getWxLoginResult:(state)=>{
    return request({
      url: `land/wxLoginResult?state=C_${state.t}&orgId=${state.orgId}`,
      method: 'GET',
    })
  },
  // 2026-09-22：已确认协议的短信登录可向未注册手机号发送验证码，其他场景保持既有账户校验。
  sendValideCode:(phone,token,autoRegister=false)=>{
    const orgId=store.getters.orgId
    return request({
      url: `land/sendValideCode?token=${token}${new Date().getTime()}&phone=${phone}&orgId=${orgId}${autoRegister===true?'&autoRegister=true':''}`,
      method: 'GET',
    })
  },
  sendValideCodeForReg:(phone,loginName,token)=>{
    const orgId=store.getters.orgId
    return request({
      url: `land/sendValideCodeForReg?token=${token}${new Date().getTime()}&loginName=${loginName}&phone=${phone}&orgId=${orgId}`,
      method: 'GET',
    })
  },  
  bindWxLogin:(phone,openId)=>{
    const orgId=store.getters.orgId
    return request({
      url: `land/bindWxLogin?celphone=${phone}&openId=${openId}&orgId=${orgId}`,
      method: 'GET',
    })
  },
  sendValideCodeForBinding:(phone,token)=>{
    const orgId=store.getters.orgId
    return request({
      url: `land/sendValideCodeForBinding?token=${token}${new Date().getTime()}&phone=${phone}&orgId=${orgId}`,
      method: 'GET',
    })
  },
  // 2026-09-22：仅明确同意协议的短信登录传递自动注册标记，旧微信/绑定调用默认不开通新账号。
  frontCodeLogin:(phone,code,orgId,autoRegister=false)=>{
    return request({
      url: `land/frontCodeLogin?code=${code}&phone=${phone}&orgId=${orgId}${autoRegister===true?'&autoRegister=true':''}`,
      method: 'GET',
    })
  },
  getMerchIdByOrgId:(orgId)=>{
    return request({
      url: `fsystem/merchIdByOrgId?orgId=${orgId}`,
      method: 'GET',
    })
  },
  getRemindVideos:()=>{
    return request({
      url: 'land/remindVideos',
      method: 'GET',
    })
  },
  getOrgInfo:(id)=>{
    return request({
      url: 'fsystem/org/'+id,
      method: 'GET',
    })
  },
  getOrgInfoByType:(id)=>{
    return request({
      url: 'system/orgs/'+id,
      method: 'GET',
    })
  },
  allBrands:()=>{
    return request({
      url: 'system/allBrands',
      method: 'GET',
    })
  },
  updateOrgInfo: (data) => {
    return request({
      url: 'system/editOrg',
      method: 'POST',
      data
    })
  },
  getAllFunctions:()=>{
    return request({
      url: 'system/allFunctions',
      method: 'GET',
    })
  },
  // 2026-08-30：分店 C 端按当前机构读取本店字典，平台公共项只读取不复制。
  getStaticData:(type,orgId=store.getters.orgId || 1000)=>{
    return request({
      url: 'land/statics/'+type,
      method: 'GET',
      params:{orgId}
    })
  },
  getCities:()=>{
    return request({
      url: 'fsystem/cities',
      method: 'GET',
    })
  },
  getNotice:()=>{
    const orgId=store.getters.orgId
    return request({
      url: `land/notices?orgId=${orgId}`,
      method: 'GET',
    })
  },
  addStaticData:(data)=>{
    return request({
      url: 'system/addStaticData',
      method: 'POST',
      data
    })
  },
  getLevels:(orgId)=>{
    return request({
      url: 'land/levels/'+orgId,
      method: 'GET'
    })
  },
  getHomeSettings:()=>{
    const orgId=store.getters.orgId
    return request({
      url: `land/homeSettings?orgId=${orgId}`,
      method: 'GET', 
    })
  },
  getSettings:()=>{
    const orgId=store.getters.orgId
    return request({
      url: `land/settings?orgId=${orgId}`,
      method: 'GET'
    })
  },
  deleteStaticData:(data)=>{
    return request({
      url: 'system/editStaticDataInvalid',
      method: 'POST',
      data
    })
  },
  getRoleFunctions:(data)=>{
    return request({
      url: 'system/functions',
      method: 'POST',
      data
    })
    
  },
  addRoleFunction:(data)=>{
    return request({
      url: 'system/addRoleFunction',
      method: 'POST',
      data
    })
    
  },
  saveSizeAttach:(data)=>{
    return request({
      url: 'system/sizeAttach',
      method: 'POST',
      data
    })
    
  },
  getSizeAttach:(id)=>{
    return request({
      url: 'fsystem/sizeAttach/'+id,
      method: 'GET', 
    })
  },
  getUrlHeader:()=>{
    return request({
      url: 'land/urlHeader',
      method: 'GET', 
    })
  },
  getVideos:()=>{
    return request({
      url: 'land/videos',
      method: 'GET', 
    })
  },

  createWXPayOrder:(data)=>{
    return request({
      url: 'merchantPayment/createOrder',
      method: 'POST', 
      data
    })
  },
  
  uploadImage:(data)=>{
    return request({
      url: 'fsystem/uploadOrgImages',
      method: 'POST',
      data,
      headers: {  
        'Content-Type': 'multipart/form-data'  
      }  
    })
    
  },
  uploadSysImages:(data)=>{
    return request({
      url: 'fsystem/uploadSysImages',
      method: 'POST',
      data,
      headers: {  
        'Content-Type': 'multipart/form-data'  
      }  
    })
    
  },
  uploadImageWithName:(data)=>{
    return request({
      url: 'land/uploadImageWithName',
      method: 'POST',
      data,
      headers: {  
        'Content-Type': 'multipart/form-data'  
      }  
    })
    
  },
  uploadImageMessage:(data: any) => {
    return request({
      url: 'land/uploadingImageMessage',
      method: 'POST',
      data
    })
  },
  getUploadImageMessage:(token) => {
    return request({
      url: `land/uploadingImageMessage?token=${token}`,
      method: 'GET'
    })
  },
  uploadBodyImages:(data)=>{
    return request({
      url: 'land/uploadImageFromBase64',
      method: 'POST',
      data,
      headers: {  
        'Content-Type': 'multipart/form-data'  
      }  
    })
    
  },
  
  uploadBokeFile:(data)=>{
    return request({
      url: 'system/uploadBokeFile',
      method: 'POST',
      data,
      headers: {  
        'Content-Type': 'multipart/form-data'  
      }  
    })
    
  },
  uploadSizeFile:(data)=>{
    return request({
      url: 'system/uploadSizeFile',
      method: 'POST',
      data,
      headers: {  
        'Content-Type': 'multipart/form-data'  
      }  
    })
    
  },
  
  getSize:(id)=>{
    return request({
      url: 'system/size/'+id,
      method: 'GET', 
    })
  },
  getSizeGroups:()=>{
    return request({
      url: 'system/sizeGroups',
      method: 'GET', 
    })
  },
  deleteSizeGroup:(id)=>{
    return request({
      url: 'system/deleteSizeGroup/'+id,
      method: 'DELETE', 
    })
  },
  addSizeGroup:(data) => {
    return request({
      url: 'system/addSizeGroup',
      method: 'POST',
      data
    }) 
  },
  addSizeData:(data) => {
    return request({
      url: 'system/addSizeData',
      method: 'POST',
      data
    }) 
  },
  editSizeData:(data) => {
    return request({
      url: 'system/editSizeData',
      method: 'POST',
      data
    }) 
  },
  deleteSizeData:(id)=> {
    return request({
      url: 'system/deleteSizeData/'+id,
      method: 'DELETE',
    }) 
  },
  deleteUnit:(id)=> {
    return request({
      url: 'system/unit/'+id,
      method: 'DELETE',
    }) 
  },
  getUnits:(orgId=store.getters.orgId || 1000)=> {
    return request({
      url: 'land/units',
      method: 'GET',
      params:{orgId}
    }) 
  },
  saveUnit:(data)=> {
    return request({
      url: 'fsystem/unit',
      method: 'POST',
      data
    }) 
  },
  updatePwd:(data)=> {
    return request({
      url: 'fsystem/updatePwd',
      method: 'POST',
      data
    }) 
  },
  getLeftCount:(id)=> {
    return request({
      url: `fsystem/getLeftCount?id=${id}`,
      method: 'GET',
    }) 
  },
  getProvence:()=> {
    return request({
      url: `fsystem/provences`,
      method: 'GET',
    }) 
  },
  getAutoSizeDataByGroupId:(groupId)=> {
    return request({
      url: `fsystem/autoSizeDataByGroupId?groupId=${groupId}`,
      method: 'GET',
    }) 
  },
  getSizeAttachs:(id)=> {
    return request({
      url: `land/sizeAttachs?id=${id}`,
      method: 'GET',
    }) 
  },
  saveCustomerFiles:(data)=> {
    return request({
      url: `fsystem/customerFiles`,
      method: 'POST',
      data
    }) 
  },
  getCustomerFiles:(id)=> {
    return request({
      url: `fsystem/customerFiles?customerId=${id}`,
      method: 'GET',
      
    }) 
  },
  getSearchingHistories:(id)=> {
    return request({
      url: `fsystem/searchingHistories?customerId=${id}`,
      method: 'GET',
      
    }) 
  },
  searchImagesByPicById:(id)=> {
    return request({
      url: `fsystem/searchImagesByPic?id=${id}`,
      method: 'GET',
      
    }) 
  },
  getSearchingResult:(id)=> {
    return request({
      url: `land/searchingResult?customerId=${id}`,
      method: 'GET',
      
    }) 
  },
  
  
  delSearchingHistories:(id)=> {
    return request({
      url: `fsystem/searchingHistories?id=${id}`,
      method: 'DELETE',
      
    }) 
  },
  delCustomerFiles:(id,path)=> {
    return request({
      url: `fsystem/customerFiles?id=${id}&path=${path}`,
      method: 'DELETE',
      
    }) 
  },
  searchImagesByPic:(data)=>{
    return request({
      url: 'fsystem/searchImagesByPic',
      method: 'POST',
      data,
      headers: {  
        'Content-Type': 'multipart/form-data'  
      }  
    })    
  },
  getHostId:(hostname)=>{
    return request({
      url: `fsystem/hostId?hostname=${hostname}`,
      method: 'GET',
    })
  },
  getProductsWithIds:(data)=> {
    return request({
      url: `fsystem/productsWithIds`,
      method: 'POST',
      data
    }) 
  },
}
